import * as React from 'react';
import { Tooltip } from 'common--design-library';


export interface IIconTooltipProps {
    targetid: string;
    target: React.ReactNode;
    children?: React.ReactNode;
    placement?: Popper.Placement;
    allowOnTouchScreen?: boolean;
    className?: string;

}


export const IconTooltip: React.FC<IIconTooltipProps> = (props: IIconTooltipProps) => {
    const [isOpen, setIsOpen] = React.useState<boolean>(false);

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    }

    return (
        <React.Fragment>
            {props.target}
            <Tooltip
                targetid={props.targetid}
                targetFactory={(p) => <div {...p}></div>}
                isOpen={isOpen}
                toggle={toggleOpen}
                autohide={false}
                allowOnTouchScreen={props.allowOnTouchScreen}
                placement={props.placement || "bottom"}
                className={props.className}
            >
                {props.children}
            </Tooltip>
        </React.Fragment>
    );
}
